import { createApiRequest } from "../common";
import { CancelOrgInviteRequestContent } from '@equaliq/api-model-v2';

export const cancelOrgInviteApi = async (request: CancelOrgInviteRequestContent): Promise<void> => {
  const apiRequest = createApiRequest<void>('post', '/orgs/invites/cancel');
  return apiRequest(request);
};
